export const sanctionedCountryCodes = ["AF", "BY", "BI", "CF", "CD", "EG", "ER", "IR", "IQ", "LB", "SY", "LY", "ML", "KP", "GN", "GW", "SO", "SS", "SD", "TN", "UA", "VE", "YE", "ZW"];

export const UKCountryCodes = ["GB"];


export function getCountryList(sortPropertyName = "country") {
  return [...COUNTRIES]; //.sort(sortCountries)
}

export const COUNTRIES = [
  {
    num_code: "826",
    code: "GB",
    alpha_3_code: "GBR",
    country: "United Kingdom",
    nationality: "British, UK"
  },
  {
    num_code: "4",
    code: "AF",
    alpha_3_code: "AFG",
    country: "Afghanistan",
    nationality: "Afghan"
  },
  {
    num_code: "248",
    code: "AX",
    alpha_3_code: "ALA",
    country: "Aland Islands",
    nationality: "Aland Island"
  },
  {
    num_code: "8",
    code: "AL",
    alpha_3_code: "ALB",
    country: "Albania",
    nationality: "Albanian"
  },
  {
    num_code: "12",
    code: "DZ",
    alpha_3_code: "DZA",
    country: "Algeria",
    nationality: "Algerian"
  },
  {
    num_code: "16",
    code: "AS",
    alpha_3_code: "ASM",
    country: "American Samoa",
    nationality: "American Samoan"
  },
  {
    num_code: "20",
    code: "AD",
    alpha_3_code: "AND",
    country: "Andorra",
    nationality: "Andorran"
  },
  {
    num_code: "24",
    code: "AO",
    alpha_3_code: "AGO",
    country: "Angola",
    nationality: "Angolan"
  },
  {
    num_code: "660",
    code: "AI",
    alpha_3_code: "AIA",
    country: "Anguilla",
    nationality: "Anguillan"
  },
  {
    num_code: "10",
    code: "AQ",
    alpha_3_code: "ATA",
    country: "Antarctica",
    nationality: "Antarctic"
  },
  {
    num_code: "28",
    code: "AG",
    alpha_3_code: "ATG",
    country: "Antigua and Barbuda",
    nationality: "Antiguan or Barbudan"
  },
  {
    num_code: "32",
    code: "AR",
    alpha_3_code: "ARG",
    country: "Argentina",
    nationality: "Argentine"
  },
  {
    num_code: "51",
    code: "AM",
    alpha_3_code: "ARM",
    country: "Armenia",
    nationality: "Armenian"
  },
  {
    num_code: "533",
    code: "AW",
    alpha_3_code: "ABW",
    country: "Aruba",
    nationality: "Aruban"
  },
  {
    num_code: "36",
    code: "AU",
    alpha_3_code: "AUS",
    country: "Australia",
    nationality: "Australian"
  },
  {
    num_code: "40",
    code: "AT",
    alpha_3_code: "AUT",
    country: "Austria",
    nationality: "Austrian"
  },
  {
    num_code: "31",
    code: "AZ",
    alpha_3_code: "AZE",
    country: "Azerbaijan",
    nationality: "Azerbaijani, Azeri"
  },
  {
    num_code: "44",
    code: "BS",
    alpha_3_code: "BHS",
    country: "Bahamas",
    nationality: "Bahamian"
  },
  {
    num_code: "48",
    code: "BH",
    alpha_3_code: "BHR",
    country: "Bahrain",
    nationality: "Bahraini"
  },
  {
    num_code: "50",
    code: "BD",
    alpha_3_code: "BGD",
    country: "Bangladesh",
    nationality: "Bangladeshi"
  },
  {
    num_code: "52",
    code: "BB",
    alpha_3_code: "BRB",
    country: "Barbados",
    nationality: "Barbadian"
  },
  {
    num_code: "112",
    code: "BY",
    alpha_3_code: "BLR",
    country: "Belarus",
    nationality: "Belarusian"
  },
  {
    num_code: "56",
    code: "BE",
    alpha_3_code: "BEL",
    country: "Belgium",
    nationality: "Belgian"
  },
  {
    num_code: "84",
    code: "BZ",
    alpha_3_code: "BLZ",
    country: "Belize",
    nationality: "Belizean"
  },
  {
    num_code: "204",
    code: "BJ",
    alpha_3_code: "BEN",
    country: "Benin",
    nationality: "Beninese, Beninois"
  },
  {
    num_code: "60",
    code: "BM",
    alpha_3_code: "BMU",
    country: "Bermuda",
    nationality: "Bermudian, Bermudan"
  },
  {
    num_code: "64",
    code: "BT",
    alpha_3_code: "BTN",
    country: "Bhutan",
    nationality: "Bhutanese"
  },
  {
    num_code: "68",
    code: "BO",
    alpha_3_code: "BOL",
    country: "Bolivia (Plurinational State of)",
    nationality: "Bolivian"
  },
  {
    num_code: "535",
    code: "BQ",
    alpha_3_code: "BES",
    country: "Bonaire, Sint Eustatius and Saba",
    nationality: "Bonaire"
  },
  {
    num_code: "70",
    code: "BA",
    alpha_3_code: "BIH",
    country: "Bosnia and Herzegovina",
    nationality: "Bosnian or Herzegovinian"
  },
  {
    num_code: "72",
    code: "BW",
    alpha_3_code: "BWA",
    country: "Botswana",
    nationality: "Motswana, Botswanan"
  },
  {
    num_code: "74",
    code: "BV",
    alpha_3_code: "BVT",
    country: "Bouvet Island",
    nationality: "Bouvet Island"
  },
  {
    num_code: "76",
    code: "BR",
    alpha_3_code: "BRA",
    country: "Brazil",
    nationality: "Brazilian"
  },
  {
    num_code: "86",
    code: "IO",
    alpha_3_code: "IOT",
    country: "British Indian Ocean Territory",
    nationality: "BIOT"
  },
  {
    num_code: "96",
    code: "BN",
    alpha_3_code: "BRN",
    country: "Brunei Darussalam",
    nationality: "Bruneian"
  },
  {
    num_code: "100",
    code: "BG",
    alpha_3_code: "BGR",
    country: "Bulgaria",
    nationality: "Bulgarian"
  },
  {
    num_code: "854",
    code: "BF",
    alpha_3_code: "BFA",
    country: "Burkina Faso",
    nationality: "Burkinab\u00e9"
  },
  {
    num_code: "108",
    code: "BI",
    alpha_3_code: "BDI",
    country: "Burundi",
    nationality: "Burundian"
  },
  {
    num_code: "132",
    code: "CV",
    alpha_3_code: "CPV",
    country: "Cabo Verde",
    nationality: "Cabo Verdean"
  },
  {
    num_code: "116",
    code: "KH",
    alpha_3_code: "KHM",
    country: "Cambodia",
    nationality: "Cambodian"
  },
  {
    num_code: "120",
    code: "CM",
    alpha_3_code: "CMR",
    country: "Cameroon",
    nationality: "Cameroonian"
  },
  {
    num_code: "124",
    code: "CA",
    alpha_3_code: "CAN",
    country: "Canada",
    nationality: "Canadian"
  },
  {
    num_code: "136",
    code: "KY",
    alpha_3_code: "CYM",
    country: "Cayman Islands",
    nationality: "Caymanian"
  },
  {
    num_code: "140",
    code: "CF",
    alpha_3_code: "CAF",
    country: "Central African Republic",
    nationality: "Central African"
  },
  {
    num_code: "148",
    code: "TD",
    alpha_3_code: "TCD",
    country: "Chad",
    nationality: "Chadian"
  },
  {
    num_code: "152",
    code: "CL",
    alpha_3_code: "CHL",
    country: "Chile",
    nationality: "Chilean"
  },
  {
    num_code: "156",
    code: "CN",
    alpha_3_code: "CHN",
    country: "China",
    nationality: "Chinese"
  },
  {
    num_code: "162",
    code: "CX",
    alpha_3_code: "CXR",
    country: "Christmas Island",
    nationality: "Christmas Island"
  },
  {
    num_code: "166",
    code: "CC",
    alpha_3_code: "CCK",
    country: "Cocos (Keeling) Islands",
    nationality: "Cocos Island"
  },
  {
    num_code: "170",
    code: "CO",
    alpha_3_code: "COL",
    country: "Colombia",
    nationality: "Colombian"
  },
  {
    num_code: "174",
    code: "KM",
    alpha_3_code: "COM",
    country: "Comoros",
    nationality: "Comoran, Comorian"
  },
  {
    num_code: "178",
    code: "CG",
    alpha_3_code: "COG",
    country: "Congo (Republic of the)",
    nationality: "Congolese"
  },
  {
    num_code: "180",
    code: "CD",
    alpha_3_code: "COD",
    country: "Congo (Democratic Republic of the)",
    nationality: "Congolese"
  },
  {
    num_code: "184",
    code: "CK",
    alpha_3_code: "COK",
    country: "Cook Islands",
    nationality: "Cook Island"
  },
  {
    num_code: "188",
    code: "CR",
    alpha_3_code: "CRI",
    country: "Costa Rica",
    nationality: "Costa Rican"
  },
  {
    num_code: "384",
    code: "CI",
    alpha_3_code: "CIV",
    country: "C\u00f4te d'Ivoire",
    nationality: "Ivorian"
  },
  {
    num_code: "191",
    code: "HR",
    alpha_3_code: "HRV",
    country: "Croatia",
    nationality: "Croatian"
  },
  {
    num_code: "192",
    code: "CU",
    alpha_3_code: "CUB",
    country: "Cuba",
    nationality: "Cuban"
  },
  {
    num_code: "531",
    code: "CW",
    alpha_3_code: "CUW",
    country: "Cura\u00e7ao",
    nationality: "Cura\u00e7aoan"
  },
  {
    num_code: "196",
    code: "CY",
    alpha_3_code: "CYP",
    country: "Cyprus",
    nationality: "Cypriot"
  },
  {
    num_code: "203",
    code: "CZ",
    alpha_3_code: "CZE",
    country: "Czech Republic",
    nationality: "Czech"
  },
  {
    num_code: "208",
    code: "DK",
    alpha_3_code: "DNK",
    country: "Denmark",
    nationality: "Danish"
  },
  {
    num_code: "262",
    code: "DJ",
    alpha_3_code: "DJI",
    country: "Djibouti",
    nationality: "Djiboutian"
  },
  {
    num_code: "212",
    code: "DM",
    alpha_3_code: "DMA",
    country: "Dominica",
    nationality: "Dominican"
  },
  {
    num_code: "214",
    code: "DO",
    alpha_3_code: "DOM",
    country: "Dominican Republic",
    nationality: "Dominican"
  },
  {
    num_code: "218",
    code: "EC",
    alpha_3_code: "ECU",
    country: "Ecuador",
    nationality: "Ecuadorian"
  },
  {
    num_code: "818",
    code: "EG",
    alpha_3_code: "EGY",
    country: "Egypt",
    nationality: "Egyptian"
  },
  {
    num_code: "222",
    code: "SV",
    alpha_3_code: "SLV",
    country: "El Salvador",
    nationality: "Salvadoran"
  },
  {
    num_code: "226",
    code: "GQ",
    alpha_3_code: "GNQ",
    country: "Equatorial Guinea",
    nationality: "Equatorial Guinean, Equatoguinean"
  },
  {
    num_code: "232",
    code: "ER",
    alpha_3_code: "ERI",
    country: "Eritrea",
    nationality: "Eritrean"
  },
  {
    num_code: "233",
    code: "EE",
    alpha_3_code: "EST",
    country: "Estonia",
    nationality: "Estonian"
  },
  {
    num_code: "231",
    code: "ET",
    alpha_3_code: "ETH",
    country: "Ethiopia",
    nationality: "Ethiopian"
  },
  {
    num_code: "238",
    code: "FK",
    alpha_3_code: "FLK",
    country: "Falkland Islands (Malvinas)",
    nationality: "Falkland Island"
  },
  {
    num_code: "234",
    code: "FO",
    alpha_3_code: "FRO",
    country: "Faroe Islands",
    nationality: "Faroese"
  },
  {
    num_code: "242",
    code: "FJ",
    alpha_3_code: "FJI",
    country: "Fiji",
    nationality: "Fijian"
  },
  {
    num_code: "246",
    code: "FI",
    alpha_3_code: "FIN",
    country: "Finland",
    nationality: "Finnish"
  },
  {
    num_code: "250",
    code: "FR",
    alpha_3_code: "FRA",
    country: "France",
    nationality: "French"
  },
  {
    num_code: "254",
    code: "GF",
    alpha_3_code: "GUF",
    country: "French Guiana",
    nationality: "French Guianese"
  },
  {
    num_code: "258",
    code: "PF",
    alpha_3_code: "PYF",
    country: "French Polynesia",
    nationality: "French Polynesian"
  },
  {
    num_code: "260",
    code: "TF",
    alpha_3_code: "ATF",
    country: "French Southern Territories",
    nationality: "French Southern Territories"
  },
  {
    num_code: "266",
    code: "GA",
    alpha_3_code: "GAB",
    country: "Gabon",
    nationality: "Gabonese"
  },
  {
    num_code: "270",
    code: "GM",
    alpha_3_code: "GMB",
    country: "Gambia",
    nationality: "Gambian"
  },
  {
    num_code: "268",
    code: "GE",
    alpha_3_code: "GEO",
    country: "Georgia",
    nationality: "Georgian"
  },
  {
    num_code: "276",
    code: "DE",
    alpha_3_code: "DEU",
    country: "Germany",
    nationality: "German"
  },
  {
    num_code: "288",
    code: "GH",
    alpha_3_code: "GHA",
    country: "Ghana",
    nationality: "Ghanaian"
  },
  {
    num_code: "292",
    code: "GI",
    alpha_3_code: "GIB",
    country: "Gibraltar",
    nationality: "Gibraltar"
  },
  {
    num_code: "300",
    code: "GR",
    alpha_3_code: "GRC",
    country: "Greece",
    nationality: "Greek, Hellenic"
  },
  {
    num_code: "304",
    code: "GL",
    alpha_3_code: "GRL",
    country: "Greenland",
    nationality: "Greenlandic"
  },
  {
    num_code: "308",
    code: "GD",
    alpha_3_code: "GRD",
    country: "Grenada",
    nationality: "Grenadian"
  },
  {
    num_code: "312",
    code: "GP",
    alpha_3_code: "GLP",
    country: "Guadeloupe",
    nationality: "Guadeloupe"
  },
  {
    num_code: "316",
    code: "GU",
    alpha_3_code: "GUM",
    country: "Guam",
    nationality: "Guamanian, Guambat"
  },
  {
    num_code: "320",
    code: "GT",
    alpha_3_code: "GTM",
    country: "Guatemala",
    nationality: "Guatemalan"
  },
  {
    num_code: "831",
    code: "GG",
    alpha_3_code: "GGY",
    country: "Guernsey",
    nationality: "Channel Island"
  },
  {
    num_code: "324",
    code: "GN",
    alpha_3_code: "GIN",
    country: "Guinea",
    nationality: "Guinean"
  },
  {
    num_code: "624",
    code: "GW",
    alpha_3_code: "GNB",
    country: "Guinea-Bissau",
    nationality: "Bissau-Guinean"
  },
  {
    num_code: "328",
    code: "GY",
    alpha_3_code: "GUY",
    country: "Guyana",
    nationality: "Guyanese"
  },
  {
    num_code: "332",
    code: "HT",
    alpha_3_code: "HTI",
    country: "Haiti",
    nationality: "Haitian"
  },
  {
    num_code: "334",
    code: "HM",
    alpha_3_code: "HMD",
    country: "Heard Island and McDonald Islands",
    nationality: "Heard Island or McDonald Islands"
  },
  {
    num_code: "336",
    code: "VA",
    alpha_3_code: "VAT",
    country: "Vatican City State",
    nationality: "Vatican"
  },
  {
    num_code: "340",
    code: "HN",
    alpha_3_code: "HND",
    country: "Honduras",
    nationality: "Honduran"
  },
  {
    num_code: "344",
    code: "HK",
    alpha_3_code: "HKG",
    country: "Hong Kong",
    nationality: "Hong Kong, Hong Kongese"
  },
  {
    num_code: "348",
    code: "HU",
    alpha_3_code: "HUN",
    country: "Hungary",
    nationality: "Hungarian, Magyar"
  },
  {
    num_code: "352",
    code: "IS",
    alpha_3_code: "ISL",
    country: "Iceland",
    nationality: "Icelandic"
  },
  {
    num_code: "356",
    code: "IN",
    alpha_3_code: "IND",
    country: "India",
    nationality: "Indian"
  },
  {
    num_code: "360",
    code: "ID",
    alpha_3_code: "IDN",
    country: "Indonesia",
    nationality: "Indonesian"
  },
  {
    num_code: "364",
    code: "IR",
    alpha_3_code: "IRN",
    country: "Iran",
    nationality: "Iranian, Persian"
  },
  {
    num_code: "368",
    code: "IQ",
    alpha_3_code: "IRQ",
    country: "Iraq",
    nationality: "Iraqi"
  },
  {
    num_code: "372",
    code: "IE",
    alpha_3_code: "IRL",
    country: "Ireland",
    nationality: "Irish"
  },
  {
    num_code: "833",
    code: "IM",
    alpha_3_code: "IMN",
    country: "Isle of Man",
    nationality: "Manx"
  },
  {
    num_code: "376",
    code: "IL",
    alpha_3_code: "ISR",
    country: "Israel",
    nationality: "Israeli"
  },
  {
    num_code: "380",
    code: "IT",
    alpha_3_code: "ITA",
    country: "Italy",
    nationality: "Italian"
  },
  {
    num_code: "388",
    code: "JM",
    alpha_3_code: "JAM",
    country: "Jamaica",
    nationality: "Jamaican"
  },
  {
    num_code: "392",
    code: "JP",
    alpha_3_code: "JPN",
    country: "Japan",
    nationality: "Japanese"
  },
  {
    num_code: "832",
    code: "JE",
    alpha_3_code: "JEY",
    country: "Jersey",
    nationality: "Channel Island"
  },
  {
    num_code: "400",
    code: "JO",
    alpha_3_code: "JOR",
    country: "Jordan",
    nationality: "Jordanian"
  },
  {
    num_code: "398",
    code: "KZ",
    alpha_3_code: "KAZ",
    country: "Kazakhstan",
    nationality: "Kazakhstani, Kazakh"
  },
  {
    num_code: "404",
    code: "KE",
    alpha_3_code: "KEN",
    country: "Kenya",
    nationality: "Kenyan"
  },
  {
    num_code: "296",
    code: "KI",
    alpha_3_code: "KIR",
    country: "Kiribati",
    nationality: "I-Kiribati"
  },
  {
    num_code: "408",
    code: "KP",
    alpha_3_code: "PRK",
    country: "Korea (Democratic People's Republic of)",
    nationality: "North Korean"
  },
  {
    num_code: "410",
    code: "KR",
    alpha_3_code: "KOR",
    country: "Korea (Republic of)",
    nationality: "South Korean"
  },
  {
    num_code: "414",
    code: "KW",
    alpha_3_code: "KWT",
    country: "Kuwait",
    nationality: "Kuwaiti"
  },
  {
    num_code: "417",
    code: "KG",
    alpha_3_code: "KGZ",
    country: "Kyrgyzstan",
    nationality: "Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz"
  },
  {
    num_code: "418",
    code: "LA",
    alpha_3_code: "LAO",
    country: "Lao People's Democratic Republic",
    nationality: "Lao, Laotian"
  },
  {
    num_code: "428",
    code: "LV",
    alpha_3_code: "LVA",
    country: "Latvia",
    nationality: "Latvian"
  },
  {
    num_code: "422",
    code: "LB",
    alpha_3_code: "LBN",
    country: "Lebanon",
    nationality: "Lebanese"
  },
  {
    num_code: "426",
    code: "LS",
    alpha_3_code: "LSO",
    country: "Lesotho",
    nationality: "Basotho"
  },
  {
    num_code: "430",
    code: "LR",
    alpha_3_code: "LBR",
    country: "Liberia",
    nationality: "Liberian"
  },
  {
    num_code: "434",
    code: "LY",
    alpha_3_code: "LBY",
    country: "Libya",
    nationality: "Libyan"
  },
  {
    num_code: "438",
    code: "LI",
    alpha_3_code: "LIE",
    country: "Liechtenstein",
    nationality: "Liechtenstein"
  },
  {
    num_code: "440",
    code: "LT",
    alpha_3_code: "LTU",
    country: "Lithuania",
    nationality: "Lithuanian"
  },
  {
    num_code: "442",
    code: "LU",
    alpha_3_code: "LUX",
    country: "Luxembourg",
    nationality: "Luxembourg, Luxembourgish"
  },
  {
    num_code: "446",
    code: "MO",
    alpha_3_code: "MAC",
    country: "Macao",
    nationality: "Macanese, Chinese"
  },
  {
    num_code: "807",
    code: "MK",
    alpha_3_code: "MKD",
    country: "Macedonia (the former Yugoslav Republic of)",
    nationality: "Macedonian"
  },
  {
    num_code: "450",
    code: "MG",
    alpha_3_code: "MDG",
    country: "Madagascar",
    nationality: "Malagasy"
  },
  {
    num_code: "454",
    code: "MW",
    alpha_3_code: "MWI",
    country: "Malawi",
    nationality: "Malawian"
  },
  {
    num_code: "458",
    code: "MY",
    alpha_3_code: "MYS",
    country: "Malaysia",
    nationality: "Malaysian"
  },
  {
    num_code: "462",
    code: "MV",
    alpha_3_code: "MDV",
    country: "Maldives",
    nationality: "Maldivian"
  },
  {
    num_code: "466",
    code: "ML",
    alpha_3_code: "MLI",
    country: "Mali",
    nationality: "Malian, Malinese"
  },
  {
    num_code: "470",
    code: "MT",
    alpha_3_code: "MLT",
    country: "Malta",
    nationality: "Maltese"
  },
  {
    num_code: "584",
    code: "MH",
    alpha_3_code: "MHL",
    country: "Marshall Islands",
    nationality: "Marshallese"
  },
  {
    num_code: "474",
    code: "MQ",
    alpha_3_code: "MTQ",
    country: "Martinique",
    nationality: "Martiniquais, Martinican"
  },
  {
    num_code: "478",
    code: "MR",
    alpha_3_code: "MRT",
    country: "Mauritania",
    nationality: "Mauritanian"
  },
  {
    num_code: "480",
    code: "MU",
    alpha_3_code: "MUS",
    country: "Mauritius",
    nationality: "Mauritian"
  },
  {
    num_code: "175",
    code: "YT",
    alpha_3_code: "MYT",
    country: "Mayotte",
    nationality: "Mahoran"
  },
  {
    num_code: "484",
    code: "MX",
    alpha_3_code: "MEX",
    country: "Mexico",
    nationality: "Mexican"
  },
  {
    num_code: "583",
    code: "FM",
    alpha_3_code: "FSM",
    country: "Micronesia (Federated States of)",
    nationality: "Micronesian"
  },
  {
    num_code: "498",
    code: "MD",
    alpha_3_code: "MDA",
    country: "Moldova (Republic of)",
    nationality: "Moldovan"
  },
  {
    num_code: "492",
    code: "MC",
    alpha_3_code: "MCO",
    country: "Monaco",
    nationality: "Mon\u00e9gasque, Monacan"
  },
  {
    num_code: "496",
    code: "MN",
    alpha_3_code: "MNG",
    country: "Mongolia",
    nationality: "Mongolian"
  },
  {
    num_code: "499",
    code: "ME",
    alpha_3_code: "MNE",
    country: "Montenegro",
    nationality: "Montenegrin"
  },
  {
    num_code: "500",
    code: "MS",
    alpha_3_code: "MSR",
    country: "Montserrat",
    nationality: "Montserratian"
  },
  {
    num_code: "504",
    code: "MA",
    alpha_3_code: "MAR",
    country: "Morocco",
    nationality: "Moroccan"
  },
  {
    num_code: "508",
    code: "MZ",
    alpha_3_code: "MOZ",
    country: "Mozambique",
    nationality: "Mozambican"
  },
  {
    num_code: "104",
    code: "MM",
    alpha_3_code: "MMR",
    country: "Myanmar",
    nationality: "Burmese"
  },
  {
    num_code: "516",
    code: "NA",
    alpha_3_code: "NAM",
    country: "Namibia",
    nationality: "Namibian"
  },
  {
    num_code: "520",
    code: "NR",
    alpha_3_code: "NRU",
    country: "Nauru",
    nationality: "Nauruan"
  },
  {
    num_code: "524",
    code: "NP",
    alpha_3_code: "NPL",
    country: "Nepal",
    nationality: "Nepali, Nepalese"
  },
  {
    num_code: "528",
    code: "NL",
    alpha_3_code: "NLD",
    country: "Netherlands",
    nationality: "Dutch, Netherlandic"
  },
  {
    num_code: "540",
    code: "NC",
    alpha_3_code: "NCL",
    country: "New Caledonia",
    nationality: "New Caledonian"
  },
  {
    num_code: "554",
    code: "NZ",
    alpha_3_code: "NZL",
    country: "New Zealand",
    nationality: "New Zealand, NZ"
  },
  {
    num_code: "558",
    code: "NI",
    alpha_3_code: "NIC",
    country: "Nicaragua",
    nationality: "Nicaraguan"
  },
  {
    num_code: "562",
    code: "NE",
    alpha_3_code: "NER",
    country: "Niger",
    nationality: "Nigerien"
  },
  {
    num_code: "566",
    code: "NG",
    alpha_3_code: "NGA",
    country: "Nigeria",
    nationality: "Nigerian"
  },
  {
    num_code: "570",
    code: "NU",
    alpha_3_code: "NIU",
    country: "Niue",
    nationality: "Niuean"
  },
  {
    num_code: "574",
    code: "NF",
    alpha_3_code: "NFK",
    country: "Norfolk Island",
    nationality: "Norfolk Island"
  },
  {
    num_code: "580",
    code: "MP",
    alpha_3_code: "MNP",
    country: "Northern Mariana Islands",
    nationality: "Northern Marianan"
  },
  {
    num_code: "578",
    code: "NO",
    alpha_3_code: "NOR",
    country: "Norway",
    nationality: "Norwegian"
  },
  {
    num_code: "512",
    code: "OM",
    alpha_3_code: "OMN",
    country: "Oman",
    nationality: "Omani"
  },
  {
    num_code: "586",
    code: "PK",
    alpha_3_code: "PAK",
    country: "Pakistan",
    nationality: "Pakistani"
  },
  {
    num_code: "585",
    code: "PW",
    alpha_3_code: "PLW",
    country: "Palau",
    nationality: "Palauan"
  },
  {
    num_code: "275",
    code: "PS",
    alpha_3_code: "PSE",
    country: "Palestine, State of",
    nationality: "Palestinian"
  },
  {
    num_code: "591",
    code: "PA",
    alpha_3_code: "PAN",
    country: "Panama",
    nationality: "Panamanian"
  },
  {
    num_code: "598",
    code: "PG",
    alpha_3_code: "PNG",
    country: "Papua New Guinea",
    nationality: "Papua New Guinean, Papuan"
  },
  {
    num_code: "600",
    code: "PY",
    alpha_3_code: "PRY",
    country: "Paraguay",
    nationality: "Paraguayan"
  },
  {
    num_code: "604",
    code: "PE",
    alpha_3_code: "PER",
    country: "Peru",
    nationality: "Peruvian"
  },
  {
    num_code: "608",
    code: "PH",
    alpha_3_code: "PHL",
    country: "Philippines",
    nationality: "Philippine, Filipino"
  },
  {
    num_code: "612",
    code: "PN",
    alpha_3_code: "PCN",
    country: "Pitcairn",
    nationality: "Pitcairn Island"
  },
  {
    num_code: "616",
    code: "PL",
    alpha_3_code: "POL",
    country: "Poland",
    nationality: "Polish"
  },
  {
    num_code: "620",
    code: "PT",
    alpha_3_code: "PRT",
    country: "Portugal",
    nationality: "Portuguese"
  },
  {
    num_code: "630",
    code: "PR",
    alpha_3_code: "PRI",
    country: "Puerto Rico",
    nationality: "Puerto Rican"
  },
  {
    num_code: "634",
    code: "QA",
    alpha_3_code: "QAT",
    country: "Qatar",
    nationality: "Qatari"
  },
  {
    num_code: "638",
    code: "RE",
    alpha_3_code: "REU",
    country: "R\u00e9union",
    nationality: "R\u00e9unionese, R\u00e9unionnais"
  },
  {
    num_code: "642",
    code: "RO",
    alpha_3_code: "ROU",
    country: "Romania",
    nationality: "Romanian"
  },
  {
    num_code: "643",
    code: "RU",
    alpha_3_code: "RUS",
    country: "Russian Federation",
    nationality: "Russian"
  },
  {
    num_code: "646",
    code: "RW",
    alpha_3_code: "RWA",
    country: "Rwanda",
    nationality: "Rwandan"
  },
  {
    num_code: "652",
    code: "BL",
    alpha_3_code: "BLM",
    country: "Saint Barth\u00e9lemy",
    nationality: "Barth\u00e9lemois"
  },
  {
    num_code: "654",
    code: "SH",
    alpha_3_code: "SHN",
    country: "Saint Helena, Ascension and Tristan da Cunha",
    nationality: "Saint Helenian"
  },
  {
    num_code: "659",
    code: "KN",
    alpha_3_code: "KNA",
    country: "Saint Kitts and Nevis",
    nationality: "Kittitian or Nevisian"
  },
  {
    num_code: "662",
    code: "LC",
    alpha_3_code: "LCA",
    country: "Saint Lucia",
    nationality: "Saint Lucian"
  },
  {
    num_code: "663",
    code: "MF",
    alpha_3_code: "MAF",
    country: "Saint Martin (French part)",
    nationality: "Saint-Martinoise"
  },
  {
    num_code: "666",
    code: "PM",
    alpha_3_code: "SPM",
    country: "Saint Pierre and Miquelon",
    nationality: "Saint-Pierrais or Miquelonnais"
  },
  {
    num_code: "670",
    code: "VC",
    alpha_3_code: "VCT",
    country: "Saint Vincent and the Grenadines",
    nationality: "Saint Vincentian, Vincentian"
  },
  {
    num_code: "882",
    code: "WS",
    alpha_3_code: "WSM",
    country: "Samoa",
    nationality: "Samoan"
  },
  {
    num_code: "674",
    code: "SM",
    alpha_3_code: "SMR",
    country: "San Marino",
    nationality: "Sammarinese"
  },
  {
    num_code: "678",
    code: "ST",
    alpha_3_code: "STP",
    country: "Sao Tome and Principe",
    nationality: "S\u00e3o Tom\u00e9an"
  },
  {
    num_code: "682",
    code: "SA",
    alpha_3_code: "SAU",
    country: "Saudi Arabia",
    nationality: "Saudi, Saudi Arabian"
  },
  {
    num_code: "686",
    code: "SN",
    alpha_3_code: "SEN",
    country: "Senegal",
    nationality: "Senegalese"
  },
  {
    num_code: "688",
    code: "RS",
    alpha_3_code: "SRB",
    country: "Serbia",
    nationality: "Serbian"
  },
  {
    num_code: "690",
    code: "SC",
    alpha_3_code: "SYC",
    country: "Seychelles",
    nationality: "Seychellois"
  },
  {
    num_code: "694",
    code: "SL",
    alpha_3_code: "SLE",
    country: "Sierra Leone",
    nationality: "Sierra Leonean"
  },
  {
    num_code: "702",
    code: "SG",
    alpha_3_code: "SGP",
    country: "Singapore",
    nationality: "Singaporean"
  },
  {
    num_code: "534",
    code: "SX",
    alpha_3_code: "SXM",
    country: "Sint Maarten (Dutch part)",
    nationality: "Sint Maarten"
  },
  {
    num_code: "703",
    code: "SK",
    alpha_3_code: "SVK",
    country: "Slovakia",
    nationality: "Slovak"
  },
  {
    num_code: "705",
    code: "SI",
    alpha_3_code: "SVN",
    country: "Slovenia",
    nationality: "Slovenian, Slovene"
  },
  {
    num_code: "90",
    code: "SB",
    alpha_3_code: "SLB",
    country: "Solomon Islands",
    nationality: "Solomon Island"
  },
  {
    num_code: "706",
    code: "SO",
    alpha_3_code: "SOM",
    country: "Somalia",
    nationality: "Somali, Somalian"
  },
  {
    num_code: "710",
    code: "ZA",
    alpha_3_code: "ZAF",
    country: "South Africa",
    nationality: "South African"
  },
  {
    num_code: "239",
    code: "GS",
    alpha_3_code: "SGS",
    country: "South Georgia and the South Sandwich Islands",
    nationality: "South Georgia or South Sandwich Islands"
  },
  {
    num_code: "728",
    code: "SS",
    alpha_3_code: "SSD",
    country: "South Sudan",
    nationality: "South Sudanese"
  },
  {
    num_code: "724",
    code: "ES",
    alpha_3_code: "ESP",
    country: "Spain",
    nationality: "Spanish"
  },
  {
    num_code: "144",
    code: "LK",
    alpha_3_code: "LKA",
    country: "Sri Lanka",
    nationality: "Sri Lankan"
  },
  {
    num_code: "729",
    code: "SD",
    alpha_3_code: "SDN",
    country: "Sudan",
    nationality: "Sudanese"
  },
  {
    num_code: "740",
    code: "SR",
    alpha_3_code: "SUR",
    country: "Suriname",
    nationality: "Surinamese"
  },
  {
    num_code: "744",
    code: "SJ",
    alpha_3_code: "SJM",
    country: "Svalbard and Jan Mayen",
    nationality: "Svalbard"
  },
  {
    num_code: "748",
    code: "SZ",
    alpha_3_code: "SWZ",
    country: "Swaziland",
    nationality: "Swazi"
  },
  {
    num_code: "752",
    code: "SE",
    alpha_3_code: "SWE",
    country: "Sweden",
    nationality: "Swedish"
  },
  {
    num_code: "756",
    code: "CH",
    alpha_3_code: "CHE",
    country: "Switzerland",
    nationality: "Swiss"
  },
  {
    num_code: "760",
    code: "SY",
    alpha_3_code: "SYR",
    country: "Syrian Arab Republic",
    nationality: "Syrian"
  },
  {
    num_code: "158",
    code: "TW",
    alpha_3_code: "TWN",
    country: "Taiwan, Province of China",
    nationality: "Chinese, Taiwanese"
  },
  {
    num_code: "762",
    code: "TJ",
    alpha_3_code: "TJK",
    country: "Tajikistan",
    nationality: "Tajikistani"
  },
  {
    num_code: "834",
    code: "TZ",
    alpha_3_code: "TZA",
    country: "Tanzania, United Republic of",
    nationality: "Tanzanian"
  },
  {
    num_code: "764",
    code: "TH",
    alpha_3_code: "THA",
    country: "Thailand",
    nationality: "Thai"
  },
  {
    num_code: "626",
    code: "TL",
    alpha_3_code: "TLS",
    country: "Timor-Leste",
    nationality: "Timorese"
  },
  {
    num_code: "768",
    code: "TG",
    alpha_3_code: "TGO",
    country: "Togo",
    nationality: "Togolese"
  },
  {
    num_code: "772",
    code: "TK",
    alpha_3_code: "TKL",
    country: "Tokelau",
    nationality: "Tokelauan"
  },
  {
    num_code: "776",
    code: "TO",
    alpha_3_code: "TON",
    country: "Tonga",
    nationality: "Tongan"
  },
  {
    num_code: "780",
    code: "TT",
    alpha_3_code: "TTO",
    country: "Trinidad and Tobago",
    nationality: "Trinidadian or Tobagonian"
  },
  {
    num_code: "788",
    code: "TN",
    alpha_3_code: "TUN",
    country: "Tunisia",
    nationality: "Tunisian"
  },
  {
    num_code: "792",
    code: "TR",
    alpha_3_code: "TUR",
    country: "Turkey",
    nationality: "Turkish"
  },
  {
    num_code: "795",
    code: "TM",
    alpha_3_code: "TKM",
    country: "Turkmenistan",
    nationality: "Turkmen"
  },
  {
    num_code: "796",
    code: "TC",
    alpha_3_code: "TCA",
    country: "Turks and Caicos Islands",
    nationality: "Turks and Caicos Island"
  },
  {
    num_code: "798",
    code: "TV",
    alpha_3_code: "TUV",
    country: "Tuvalu",
    nationality: "Tuvaluan"
  },
  {
    num_code: "800",
    code: "UG",
    alpha_3_code: "UGA",
    country: "Uganda",
    nationality: "Ugandan"
  },
  {
    num_code: "804",
    code: "UA",
    alpha_3_code: "UKR",
    country: "Ukraine",
    nationality: "Ukrainian"
  },
  {
    num_code: "784",
    code: "AE",
    alpha_3_code: "ARE",
    country: "United Arab Emirates",
    nationality: "Emirati, Emirian, Emiri"
  },
  {
    num_code: "581",
    code: "UM",
    alpha_3_code: "UMI",
    country: "United States Minor Outlying Islands",
    nationality: "American"
  },
  {
    num_code: "840",
    code: "US",
    alpha_3_code: "USA",
    country: "United States of America",
    nationality: "American"
  },
  {
    num_code: "858",
    code: "UY",
    alpha_3_code: "URY",
    country: "Uruguay",
    nationality: "Uruguayan"
  },
  {
    num_code: "860",
    code: "UZ",
    alpha_3_code: "UZB",
    country: "Uzbekistan",
    nationality: "Uzbekistani, Uzbek"
  },
  {
    num_code: "548",
    code: "VU",
    alpha_3_code: "VUT",
    country: "Vanuatu",
    nationality: "Ni-Vanuatu, Vanuatuan"
  },
  {
    num_code: "862",
    code: "VE",
    alpha_3_code: "VEN",
    country: "Venezuela (Bolivarian Republic of)",
    nationality: "Venezuelan"
  },
  {
    num_code: "704",
    code: "VN",
    alpha_3_code: "VNM",
    country: "Vietnam",
    nationality: "Vietnamese"
  },
  {
    num_code: "92",
    code: "VG",
    alpha_3_code: "VGB",
    country: "Virgin Islands (British)",
    nationality: "British Virgin Island"
  },
  {
    num_code: "850",
    code: "VI",
    alpha_3_code: "VIR",
    country: "Virgin Islands (U.S.)",
    nationality: "U.S. Virgin Island"
  },
  {
    num_code: "876",
    code: "WF",
    alpha_3_code: "WLF",
    country: "Wallis and Futuna",
    nationality: "Wallis and Futuna, Wallisian or Futunan"
  },
  {
    num_code: "732",
    code: "EH",
    alpha_3_code: "ESH",
    country: "Western Sahara",
    nationality: "Sahrawi, Sahrawian, Sahraouian"
  },
  {
    num_code: "887",
    code: "YE",
    alpha_3_code: "YEM",
    country: "Yemen",
    nationality: "Yemeni"
  },
  {
    num_code: "894",
    code: "ZM",
    alpha_3_code: "ZMB",
    country: "Zambia",
    nationality: "Zambian"
  },
  {
    num_code: "716",
    code: "ZW",
    alpha_3_code: "ZWE",
    country: "Zimbabwe",
    nationality: "Zimbabwean"
  }
];

export const onboardingCountries = [
  {
    code: "AT",
    nationality: "Austrian",
    country: "Austria",
    label: "CONCAT"
  },
  {
    code: "BE",
    nationality: "Belgian",
    country: "Belgium",
    label: "Belgian National Number"
  },
  {
    code: "BG",
    nationality: "Bulgarian",
    country: "Bulgaria",
    label: "Bulgarian Personal Number"
  },
  {
    code: "CY",
    nationality: "Cypriot",
    country: "Cyprus",
    label: "National Passport Number"
  },
  {
    code: "CZ",
    nationality: "Czech",
    country: "Czech Republic",
    label: "National Identification Number"
  },
  {
    code: "DE",
    nationality: "German",
    country: "Germany",
    label: "CONCAT"
  },
  {
    code: "DK",
    nationality: "Danish",
    country: "Denmark",
    label: "Personal Identity Code"
  },
  {
    code: "EE",
    nationality: "Estonian",
    country: "Estonia",
    label: "Estonian Personal Identification Code"
  },
  {
    code: "ES",
    nationality: "Spanish",
    country: "Spain",
    label: "Tax Identification Number"
  },
  {
    code: "FI",
    nationality: "Finnish",
    country: "Finland",
    label: "Personal Identity Code"
  },
  {
    code: "FR",
    nationality: "French",
    country: "France",
    label: "CONCAT"
  },
  {
    code: "GB",
    nationality: "British",
    country: "United Kingdom",
    label: "National Insurance Number"
  },
  {
    code: "GR",
    nationality: "Greek",
    country: "Greece",
    label: "10 DSS-Digit Investor Shares"
  },
  {
    code: "HR",
    nationality: "Croatian",
    country: "Croatia",
    label: "Personal Identification Number"
  },
  {
    code: "HU",
    nationality: "Hungarian",
    country: "Hungary",
    label: "CONCAT"
  },
  {
    code: "IE",
    nationality: "Irish",
    country: "Ireland",
    label: "CONCAT"
  },
  {
    code: "IS",
    nationality: "Icelandic",
    country: "Iceland",
    label: "Personal Identity Code"
  },
  {
    code: "IT",
    nationality: "Italian",
    country: "Italy",
    label: "Fiscal Code"
  },
  {
    code: "LI",
    nationality: "Liechtensteiner",
    country: "Liechtenstein",
    label: "National Passport Code"
  },
  {
    code: "LT",
    nationality: "Lithuania",
    country: "Lithuania",
    label: "Personal Code"
  },
  {
    code: "LV",
    nationality: "Latvian",
    country: "Latvia",
    label: "Personal Code"
  },
  {
    code: "MT",
    nationality: "Maltese",
    country: "Malta",
    label: "National Indentification Number"
  },
  {
    code: "NL",
    nationality: "Dutch",
    country: "Netherlands",
    label: "National Passport Number"
  },
  {
    code: "NO",
    nationality: "Norwegian",
    country: "Norway",
    label: "11 Digit Personal Identification"
  },
  {
    code: "PL",
    nationality: "Polish",
    country: "Poland",
    label: "National Indentification Number"
  },
  {
    code: "PT",
    nationality: "Portuguese",
    country: "Portugal",
    label: "Tax Number"
  },
  {
    code: "RO",
    nationality: "Romanian",
    country: "Romania",
    label: "National Indentification Number"
  },
  {
    code: "SE",
    nationality: "Swedish",
    country: "Sweden",
    label: "CONCAT"
  },
  {
    code: "SI",
    nationality: "Slovenian",
    country: "Slovenia",
    label: "CONCAT"
  },
  {
    code: "SK",
    nationality: "Slovakian",
    country: "Slovakia",
    label: "National Passport Number"
  },
  {
    code: "-",
    nationality: "",
    country: "Other",
    label: "CONCAT"
  }
];
